module.exports = __webpack_public_path__ + "media/img/about/person/jon-4eb340f9d71b59622947bd99b221c455.png";